module.exports = "/_next/static/media/a98a72ec0c779cc9473da7c579b4e2f3.svg";